module.exports = __webpack_public_path__ + "static/hiba-b8b0d4a1f4911c56e9b2d096da72ea96.jpg";